// Small display rules shared by pages (BH demo 390 sweep, 11-01).

/** A record id in the path (a UUID, or a long hex / numeric key) names a row, not a place: never show it as a crumb. */
export function isRecordId(seg) {
  return (
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(seg) ||
    /^[0-9a-f]{16,}$/i.test(seg) ||
    /^\d{6,}$/.test(seg)
  );
}

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/** '2026-10-26' → 'Oct 26' (a calendar date: read as-is, no time zone shift); missing → '—'. */
export function weekLabel(iso) {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso || '');
  if (!m) return '—';
  return `${MONTHS[Number(m[2]) - 1]} ${Number(m[3])}`;
}
